import { makeStyles } from "@material-ui/core/styles";
import BannerImage from "../../../assets/images/img-otros-plan.png";

const styles = makeStyles(theme => ({
  bannerBackground: {
    background: "#003967",
    backgroundImage: `url(${BannerImage})`,
    backgroundPosition: "right top",
    backgroundSize: "cover",
    minHeight: "550px",
    padding: "120px 300px",
    backgroundRepeat: "no-repeat",

    [theme.breakpoints.down("md")]: {
      padding: "100px 100px"
    },
    [theme.breakpoints.down("sm")]: {
      padding: "100px 50px",
      backgroundSize: "auto",
      backgroundPosition: "right 30% top",
      backgroundRepeat: "no-repeat"
    }
  },
  bannerTitle: {
    fontSize: "42px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.1",
    color: "white",
    textAlign: "center",
    marginBlockStart: "0em",
    marginBlockEnd: "0em",
    [theme.breakpoints.down("xs")]: {
      fontSize: "33px",
      maxWidth: "250px"
    }
  },
  itemContainer: {
    textAlign: "center",
    marginTop: "80px",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    "&:hover": {
      "& .iconContainer": {
        color: "white",
        background: "#0073cf"
      },
      "& .iconArrowContainer": {
        color: "#0073cf",
        background: "white"
      }
    },
    "& .iconMain": {
      width: 80
    },
    "& .iconArrow": {
      fontSize: "2rem"
    },
    "& .iconContainer": {
      color: "#0073cf",
      textAlign: "center",
      background: "white",
      borderRadius: "50%",
      width: "200px",
      height: "200px",
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      marginBottom: "30px"
    },
    "& .textIcon": {
      fontSize: "28px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "1.14",
      letterSpacing: "normal",
      textAlign: "center",
      color: "#57b4ff",
      maxWidth: "175px",
      marginBottom: "30px"
    },
    "& .iconArrowContainer": {
      textAlign: "center",
      background: "#0073cf",
      borderRadius: "50%",
      width: "60px",
      height: "60px",
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      marginBottom: "30px",
      color: "white"
    }
  },
  breadcrumbsStyle: {
    padding: "0px 16%",
    listStyle: "none",
    "& li": {
      display: "inline-block",
      fontSize: "10px",
      padding: "5px 7px",
      backgroundColor: "#d8d8d8",
      borderRadius: "10.8px",
      marginRight: "5px",
      marginBottom: "10px"
    },
    "& li a": {
      color: "#4a4a4a",
      textDecoration: "none"
    },
    "& li a:hover": {
      color: "#00338d",
      textDecoration: "underline",
      fontWeight: "bold"
    },
    [theme.breakpoints.down("md")]: {
      padding: "40px"
    },
    [theme.breakpoints.down("xs")]: {
      padding: "10px",
      marginBottom: 0,
      paddingBottom: 0
    }
  },
  pinted1: {},
  pinted2: {},
  pinted3: {}
}));

export default styles;
